// Global gender detection function
window.detectGenderByName = function(name) {
  if (!name || typeof name !== 'string') return null;
  const firstName = name.trim().split(/\s+/)[0];
  const nameLower = firstName.toLowerCase();
  
  const femaleNames = new Set(['анна','мария','ольга','татьяна','екатерина','александра','ирина','наталья','елена','светлана','галина','людмила','лариса','надежда','валентина','любовь','виктория','анастасия','вероника','полина','алина','ксения','дарья','юлия','вера','зинаида','софия','софья','василиса','евгения','кристина','марина','инна','жанна','нина','алла','оксана','карина','алёна','алена','яна','диана','лина','эльвира','раиса','зоя','агата','варвара','снежана','кира','виталина','изабелла','мелисса','арина','таисия']);
  
  const maleNames = new Set(['никита','илья','коля','ваня','дима','саша','жора','гоша','витя','серёжа','сережа','петя','стёпа','степа','максим','савва','кузя','толик','гена','вова','боря','шура','женя','валера','паша','слава','митя','граф','костя','тима','фима','захар','зосим','аркадий','игорь','олег','павел','руслан','владимир','алексей','сергей','андрей','дмитрий','иван','петр','михаил','артем','владислав','стас','станислав','федор','антон','евгений','николай','виктор','константин','вячеслав']);
  
  if (femaleNames.has(nameLower)) return 'Женский';
  if (maleNames.has(nameLower)) return 'Мужской';
  if (nameLower.endsWith('а') || nameLower.endsWith('я')) {
    const maleExceptions = ['илья','василий','никита','фока','куза','савелий','юлий'];
    if (maleExceptions.includes(nameLower)) return 'Мужской';
    return 'Женский';
  }
  return 'Мужской';
};

import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import axios from "axios";
import { 
  ShoppingBag, 
  Plus, 
  RefreshCw, 
  Search, 
  Phone,
  Mail,
  User,
  ArrowUpCircle,
  ArrowDownCircle,
  Trash2,
  Edit,
  Loader2,
  ChevronDown,
  ChevronRight,
  CheckCircle,
  XCircle,
  Bot,
  Download,
  FileDown,
  AtSign,
  Gamepad2,
  Bitcoin,
  Globe
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function OzonProfiles() {
  const [ozonProfiles, setOzonProfiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedProfiles, setSelectedProfiles] = useState(new Set());
  const [isDeletingMultiple, setIsDeletingMultiple] = useState(false);
  const [activeTab, setActiveTab] = useState('active'); // 'active', 'inactive', 'requests'
  
  // Modals
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  
  // Form state
  const [formData, setFormData] = useState({
    dolphin_profile_name: "",
    phone: "",
    name: "",
    first_name: "",
    last_name: "",
    patronymic: "",
    birth_date: "",
    gender: "",
    city: "",
    email: "",
    balance: ""
  });
  
  // Cookie parsing
  const [showCookieModal, setShowCookieModal] = useState(false);
  const [cookiesInput, setCookiesInput] = useState('');
  const [cookiePeriod, setCookiePeriod] = useState(7);
  const [isCookieParsing, setIsCookieParsing] = useState(false);

  // Transaction modal (add / edit)
  const [showTxModal, setShowTxModal] = useState(false);
  const [txMode, setTxMode] = useState('add'); // 'add' | 'edit'
  const [txProfileId, setTxProfileId] = useState(null);
  const [txForm, setTxForm] = useState({
    id: null,
    type: 'deposit',
    amount: '',
    category: '',
    method: '',
    date: '',
    time: '',
  });
  const [txSaving, setTxSaving] = useState(false);

  // ===== Transaction handlers =====
  const _todayStr = () => new Date().toISOString().slice(0, 10);
  const _timeStr = () => new Date().toTimeString().slice(0, 5);

  const openAddTx = (profileId, type = 'deposit') => {
    setTxProfileId(profileId);
    setTxMode('add');
    setTxForm({
      id: null,
      type,
      amount: '',
      category: '',
      method: type === 'deposit' ? 'Пополнение' : 'Перевод',
      date: _todayStr(),
      time: _timeStr(),
    });
    setShowTxModal(true);
  };

  const openEditTx = (profileId, tx) => {
    setTxProfileId(profileId);
    setTxMode('edit');
    setTxForm({
      id: tx.id,
      type: tx.type || 'deposit',
      amount: String(tx.amount ?? ''),
      category: tx.category || '',
      method: tx.method || '',
      date: tx.date || _todayStr(),
      time: tx.time || '',
    });
    setShowTxModal(true);
  };

  const saveTx = async () => {
    if (!txProfileId) return;
    const amt = parseFloat(String(txForm.amount).replace(',', '.'));
    if (!(amt > 0)) { toast.error('Введите корректную сумму'); return; }
    if (!txForm.date) { toast.error('Укажите дату'); return; }
    setTxSaving(true);
    try {
      const body = {
        type: txForm.type,
        amount: amt,
        method: txForm.method || (txForm.type === 'deposit' ? 'Пополнение' : 'Перевод'),
        category: txForm.category || '',
        date: txForm.date,
        time: txForm.time || '',
      };
      if (txMode === 'add') {
        await axios.post(
          `${BACKEND_URL}/api/ozon/profiles/${txProfileId}/transactions`,
          body,
          { headers: getAuthHeaders() }
        );
        toast.success('Транзакция добавлена');
      } else {
        await axios.patch(
          `${BACKEND_URL}/api/ozon/profiles/${txProfileId}/transactions/${txForm.id}`,
          body,
          { headers: getAuthHeaders() }
        );
        toast.success('Транзакция обновлена');
      }
      setShowTxModal(false);
      await fetchOzonProfiles(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message || 'Ошибка сохранения');
    } finally {
      setTxSaving(false);
    }
  };

  const deleteTx = async (profileId, txId) => {
    if (!window.confirm('Удалить транзакцию?')) return;
    try {
      await axios.delete(
        `${BACKEND_URL}/api/ozon/profiles/${profileId}/transactions/${txId}`,
        { headers: getAuthHeaders() }
      );
      toast.success('Транзакция удалена');
      await fetchOzonProfiles(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message || 'Ошибка удаления');
    }
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return { Authorization: `Bearer ${token}` };
  };

  const fetchOzonProfiles = useCallback(async (showToast = false) => {
    setIsRefreshing(true);
    setError(null);
    
    try {
      const response = await axios.get(`${API}/ozon/profiles`, {
        headers: getAuthHeaders(),
      });
      setOzonProfiles(response.data);
      if (showToast) {
        toast.success(`Загружено OZON профилей: ${response.data.length}`);
      }
    } catch (error) {
      console.error("Error fetching OZON profiles:", error);
      setError(error.response?.data?.detail || "Ошибка загрузки профилей");
      if (error.response?.status === 401) {
        toast.error("Сессия истекла");
      }
    } finally {
      setIsLoading(false);
      setIsRefreshing(false);
    }
  }, []);

  useEffect(() => {
    fetchOzonProfiles();
  }, [fetchOzonProfiles]);

  // Auto-detect gender when first_name changes in edit modal
  useEffect(() => {
    if (showEditModal && formData.first_name && !formData.gender) {
      const detectedGender = window.detectGenderByName(formData.first_name);
      if (detectedGender) {
        setFormData(prev => ({ ...prev, gender: detectedGender }));
      }
    }
  }, [formData.first_name, showEditModal]);

  const toggleRow = (profileId) => {
    setExpandedRows(prev => ({
      ...prev,
      [profileId]: !prev[profileId]
    }));
  };

  const resetForm = () => {
    setFormData({
      dolphin_profile_name: "",
      phone: "",
      name: "",
      first_name: "",
      last_name: "",
      patronymic: "",
      birth_date: "",
      gender: "",
      city: "",
      email: "",
      balance: "",
      cashinout_id: ""
    });
  };

  const handleAddProfile = async () => {
    if (!formData.dolphin_profile_name.trim()) {
      toast.error("Введите название профиля");
      return;
    }

    try {
      await axios.post(
        `${API}/ozon/profiles`,
        {
          dolphin_profile_id: 0,
          dolphin_profile_name: formData.dolphin_profile_name.trim(),
          phone: formData.phone || "",
          ozon_password: "",
          name: formData.name || null,
          email: formData.email || "не установлен",
          balance: parseFloat(formData.balance) || 0,
          is_blocked: false
        },
        { headers: getAuthHeaders() }
      );
      toast.success("Профиль добавлен");
      setShowAddModal(false);
      resetForm();
      fetchOzonProfiles();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Ошибка добавления профиля");
    }
  };

  const handleUpdateProfile = async () => {
    if (!selectedProfile) return;

    try {
      await axios.patch(
        `${API}/ozon/profiles/${selectedProfile.id}`,
        {
          dolphin_profile_name: formData.dolphin_profile_name,
          phone: formData.phone,
          name: formData.name || null,
          first_name: formData.first_name || null,
          last_name: formData.last_name || null,
          patronymic: formData.patronymic || null,
          birth_date: formData.birth_date || null,
          gender: formData.gender || null,
          city: formData.city || null,
          email: formData.email || "не установлен",
          balance: parseFloat(formData.balance) || selectedProfile.balance,
          template_balance: parseFloat(formData.template_balance) || selectedProfile.template_balance,
          cashinout_id: formData.cashinout_id ? parseInt(formData.cashinout_id, 10) : null
        },
        { headers: getAuthHeaders() }
      );
      toast.success("Профиль обновлён");
      setShowEditModal(false);
      setSelectedProfile(null);
      resetForm();
      fetchOzonProfiles();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Ошибка обновления профиля");
    }
  };

  const handleDeleteProfile = async (profileId) => {
    if (!window.confirm("Удалить профиль?")) return;

    try {
      await axios.delete(`${API}/ozon/profiles/${profileId}`, {
        headers: getAuthHeaders(),
      });
      toast.success("Профиль удалён");
      setSelectedProfiles(prev => {
        const newSet = new Set(prev);
        newSet.delete(profileId);
        return newSet;
      });
      fetchOzonProfiles();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Ошибка удаления профиля");
    }
  };

  // Функция выбора/снятия выбора профиля
  const toggleProfileSelection = (profileId) => {
    setSelectedProfiles(prev => {
      const newSet = new Set(prev);
      if (newSet.has(profileId)) {
        newSet.delete(profileId);
      } else {
        newSet.add(profileId);
      }
      return newSet;
    });
  };

  // Выбрать/снять выбор всех профилей
  const toggleSelectAll = () => {
    if (selectedProfiles.size === tabFilteredProfiles.length) {
      setSelectedProfiles(new Set());
    } else {
      setSelectedProfiles(new Set(tabFilteredProfiles.map(p => p.id)));
    }
  };

  // Удалить выбранные профили
  const handleDeleteSelected = async () => {
    if (selectedProfiles.size === 0) {
      toast.error("Выберите профили для удаления");
      return;
    }
    
    if (!window.confirm(`Удалить ${selectedProfiles.size} профилей?`)) return;
    
    setIsDeletingMultiple(true);
    let successCount = 0;
    let errorCount = 0;
    
    for (const profileId of selectedProfiles) {
      try {
        await axios.delete(`${API}/ozon/profiles/${profileId}`, {
          headers: getAuthHeaders(),
        });
        successCount++;
      } catch (error) {
        errorCount++;
        console.error(`Error deleting profile ${profileId}:`, error);
      }
    }
    
    setIsDeletingMultiple(false);
    setSelectedProfiles(new Set());
    
    if (successCount > 0) {
      toast.success(`Удалено профилей: ${successCount}`);
    }
    if (errorCount > 0) {
      toast.error(`Ошибок при удалении: ${errorCount}`);
    }
    
    fetchOzonProfiles();
  };

  const openEditModal = (profile) => {
    setSelectedProfile(profile);
    // Auto-detect gender if not set
    let detectedGender = profile.gender || "";
    if (!detectedGender && profile.first_name) {
      detectedGender = window.detectGenderByName(profile.first_name) || "";
    }
    setFormData({
      dolphin_profile_name: profile.dolphin_profile_name,
      phone: profile.phone,
      name: profile.name || "",
      first_name: profile.first_name || "",
      last_name: profile.last_name || "",
      patronymic: profile.patronymic || "",
      birth_date: profile.birth_date || "",
      gender: detectedGender,
      city: profile.city || "",
      email: profile.email || "",
      balance: profile.balance?.toString() || "",
      template_balance: profile.template_balance?.toString() || "",
      cashinout_id: profile.cashinout_id ? String(profile.cashinout_id) : ""
    });
    setShowEditModal(true);
  };
  
  // Парсинг через cookies
  const handleCookieParse = async () => {
    if (!cookiesInput.trim()) {
      toast.error("Вставьте cookies");
      return;
    }
    
    setIsCookieParsing(true);
    toast.info("🤖 Запуск парсинга через cookies...");
    
    try {
      const response = await axios.post(
        `${API}/ozon/parse-with-cookies`,
        { 
          cookies: cookiesInput, 
          period_days: cookiePeriod,
          profile_id: selectedProfile?.id || null
        },
        { headers: getAuthHeaders(), timeout: 300000 }
      );
      
      if (response.data.success) {
        toast.success(`✅ Парсинг завершён! Пополнений: ${response.data.deposits_count}, Переводов: ${response.data.withdrawals_count}`);
        fetchOzonProfiles();
        setShowCookieModal(false);
        setCookiesInput('');
      } else {
        toast.error(response.data.error || "Ошибка парсинга");
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Ошибка парсинга");
    } finally {
      setIsCookieParsing(false);
    }
  };

  const filteredProfiles = ozonProfiles.filter((profile) =>
    profile.phone?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    profile.dolphin_profile_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (profile.name && profile.name.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  // Filter by active tab
  const tabFilteredProfiles = filteredProfiles; // Единый список без фильтрации по табам

  // Launch browser with cookies
  const launchBrowser = (profile) => {
    if (!profile.cookies) {
      toast.error("Нет cookies для запуска браузера");
      return;
    }
    try {
      const cookies = JSON.parse(profile.cookies);
      const cookieStr = cookies.map(c => `${c.name}=${c.value}`).join('; ');
      const url = `https://www.ozon.ru`;
      // Open new window with cookie info
      const win = window.open('', '_blank');
      if (win) {
        win.document.write(`
          <html><head><title>Запуск браузера - ${profile.name || profile.dolphin_profile_name}</title></head>
          <body style="font-family:monospace;padding:20px;background:#1a1a2e;color:#e0e0e0">
            <h2 style="color:#4fc3f7">Профиль: ${profile.name || profile.dolphin_profile_name}</h2>
            <p>Телефон: ${profile.phone}</p>
            <h3 style="color:#81c784">Cookies для подстановки:</h3>
            <textarea style="width:100%;height:300px;background:#0d1117;color:#58a6ff;border:1px solid #30363d;padding:10px;border-radius:8px;font-size:13px">${profile.cookies}</textarea>
            <br/><br/>
            <p style="color:#ffa726">Инструкция:</p>
            <ol>
              <li>Откройте <a href="${url}" target="_blank" style="color:#4fc3f7">${url}</a></li>
              <li>Откройте DevTools (F12) → Application → Cookies</li>
              <li>Очистите текущие cookies</li>
              <li>Импортируйте cookies из текстового поля выше</li>
              <li>Обновите страницу</li>
            </ol>
            <button onclick="navigator.clipboard.writeText(document.querySelector('textarea').value);this.textContent='Скопировано!'" 
              style="padding:10px 24px;background:#4fc3f7;color:#000;border:none;border-radius:6px;cursor:pointer;font-size:14px;font-weight:bold;margin-top:10px">
              Скопировать Cookies
            </button>
          </body></html>
        `);
      }
      toast.success(`Браузер запущен для ${profile.name || profile.dolphin_profile_name}`);
    } catch (e) {
      // If cookies is just a string, try opening with it directly
      const win = window.open('', '_blank');
      if (win) {
        win.document.write(`
          <html><head><title>Cookies - ${profile.name || profile.dolphin_profile_name}</title></head>
          <body style="font-family:monospace;padding:20px;background:#1a1a2e;color:#e0e0e0">
            <h2 style="color:#4fc3f7">Профиль: ${profile.name || profile.dolphin_profile_name}</h2>
            <h3>Cookies:</h3>
            <textarea style="width:100%;height:300px;background:#0d1117;color:#58a6ff;border:1px solid #30363d;padding:10px;border-radius:8px">${profile.cookies}</textarea>
            <br/><br/>
            <button onclick="navigator.clipboard.writeText(document.querySelector('textarea').value);this.textContent='Скопировано!'" 
              style="padding:10px 24px;background:#4fc3f7;color:#000;border:none;border-radius:6px;cursor:pointer;font-size:14px;font-weight:bold">
              Скопировать Cookies
            </button>
          </body></html>
        `);
      }
    }
  };

  const getDeposits = (profile) => profile.transactions?.filter(t => t.type === "deposit") || [];
  const getWithdrawals = (profile) => profile.transactions?.filter(t => t.type === "withdrawal") || [];
  const getTotalDeposits = (profile) => getDeposits(profile).reduce((sum, t) => sum + t.amount, 0);
  const getTotalWithdrawals = (profile) => getWithdrawals(profile).reduce((sum, t) => sum + t.amount, 0);

  // Генерация email из имени и фамилии
  const generateEmail = async (profile) => {
    if (!profile.name) {
      toast.error("Нет имени для генерации email");
      return;
    }
    
    // Транслитерация
    const translitMap = {
      'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'e',
      'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm',
      'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
      'ф': 'f', 'х': 'h', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'sch',
      'ъ': '', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu', 'я': 'ya'
    };
    
    const translit = (str) => {
      return str.toLowerCase().split('').map(char => translitMap[char] || char).join('');
    };
    
    // Разбиваем имя на части
    const nameParts = profile.name.trim().split(/\s+/);
    let emailBase = '';
    
    if (nameParts.length >= 2) {
      // Имя.Фамилия или Фамилия.Имя
      emailBase = translit(nameParts[0]) + '.' + translit(nameParts[1]);
    } else {
      emailBase = translit(nameParts[0]);
    }
    
    // Случайный домен
    const domains = ['mail.ru', 'gmail.com'];
    const randomDomain = domains[Math.floor(Math.random() * domains.length)];
    
    // Добавляем случайные цифры
    const randomNum = Math.floor(Math.random() * 1000);
    const email = `${emailBase}${randomNum}@${randomDomain}`;
    
    // Сохраняем в профиль
    try {
      await axios.patch(
        `${API}/ozon/profiles/${profile.id}`,
        { email: email },
        { headers: getAuthHeaders() }
      );
      toast.success(`Email сгенерирован: ${email}`);
      fetchOzonProfiles();
    } catch (error) {
      toast.error("Ошибка сохранения email");
    }
  };

  // Generate Betboom archive with both screenshots
  const handleGenerateBetboomArchive = async (profile) => {
    toast.info("Генерация архива Betboom...");
    
    try {
      const response = await axios.post(
        `${API}/betboom/generate-archive`,
        {
          profile_id: profile.id,
          base_url: window.location.origin
        },
        { headers: getAuthHeaders() }
      );
      
      if (response.data.success) {
        // Convert base64 to blob and download
        const byteCharacters = atob(response.data.archive);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/zip' });
        
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = response.data.filename;
        link.click();
        
        URL.revokeObjectURL(link.href);
        toast.success(`Архив ${response.data.filename} скачан!`);
      } else {
        toast.error(`Ошибка: ${response.data.error}`);
      }
    } catch (error) {
      console.error("Archive error:", error);
      toast.error("Ошибка генерации архива");
    }
  };

  // Генерация архива Cashinout
  const handleGenerateCashinoutArchive = async (profile) => {
    toast.info("Генерация архива Cashinout...");
    
    try {
      const response = await axios.post(
        `${API}/cashinout/generate-archive`,
        {
          profile_id: profile.id,
          base_url: window.location.origin
        },
        { headers: getAuthHeaders() }
      );
      
      if (response.data.success) {
        // Convert base64 to blob and download
        const byteCharacters = atob(response.data.archive);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/zip' });
        
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = response.data.filename;
        link.click();
        
        URL.revokeObjectURL(link.href);
        toast.success(`Архив Cashinout ${response.data.filename} скачан!`);
      } else {
        toast.error(`Ошибка: ${response.data.error}`);
      }
    } catch (error) {
      console.error("Cashinout archive error:", error);
      toast.error("Ошибка генерации архива Cashinout");
    }
  };

  // Создание заявки
  const handleCreateRequest = async (profile) => {
    try {
      const response = await axios.post(
        `${API}/requests`,
        {
          profile_id: profile.id,
          profile_name: profile.name || profile.dolphin_profile_name || "Без имени",
          profile_phone: profile.phone || "",
          balance: profile.balance || 0,
          note: ""
        },
        { headers: getAuthHeaders() }
      );
      
      if (response.data.success) {
        toast.success(`Заявка создана для ${profile.name || profile.dolphin_profile_name}`);
      } else {
        toast.error("Ошибка создания заявки");
      }
    } catch (error) {
      console.error("Request creation error:", error);
      toast.error("Ошибка создания заявки");
    }
  };

  // Статистика
  const blockedProfiles = ozonProfiles.filter(p => p.is_blocked);
  const activeProfiles = ozonProfiles.filter(p => !p.is_blocked);
  const blockedBalance = blockedProfiles.reduce((sum, p) => sum + (p.balance || 0), 0);

  const handleDownloadPhones = () => {
    const phones = activeProfiles
      .map(p => p.phone)
      .filter(Boolean);
    if (phones.length === 0) {
      toast.error('Нет номеров для скачивания');
      return;
    }
        const text = phones.join('\n');
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'phones_active.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    toast.success('Скачано ' + phones.length + ' номеров');
  };
  const activeBalance = activeProfiles.reduce((sum, p) => sum + (p.balance || 0), 0);
  const totalBalance = ozonProfiles.reduce((sum, p) => sum + (p.balance || 0), 0);

  return (
    <div className="animate-fade-in" data-testid="ozon-profiles-page">
      {/* Статистика */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <Card className="bg-slate-50 border-slate-200">
          <CardContent className="p-4">
            <div className="flex items-center gap-2 text-slate-700">
              <User className="w-5 h-5" />
              <span className="text-sm font-medium">Всего профилей</span>
            </div>
            <div className="mt-2">
              <span className="text-2xl font-bold text-slate-800">{ozonProfiles.length}</span>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-blue-50 border-blue-200">
          <CardContent className="p-4">
            <div className="flex items-center gap-2 text-blue-700">
              <ShoppingBag className="w-5 h-5" />
              <span className="text-sm font-medium">Общий баланс</span>
            </div>
            <div className="mt-2">
              <span className="text-2xl font-bold text-blue-800">{totalBalance.toLocaleString()} ₽</span>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-green-50 border-green-200">
          <CardContent className="p-4">
            <div className="flex items-center gap-2 text-green-700">
              <CheckCircle className="w-5 h-5" />
              <span className="text-sm font-medium">Активные</span>
            </div>
            <div className="mt-2">
              <span className="text-2xl font-bold text-green-800">{activeProfiles.length}</span>
              <span className="text-sm text-green-600 ml-2">/ {activeBalance.toLocaleString()} ₽</span>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-red-50 border-red-200">
          <CardContent className="p-4">
            <div className="flex items-center gap-2 text-red-700">
              <XCircle className="w-5 h-5" />
              <span className="text-sm font-medium">Заблокированы</span>
            </div>
            <div className="mt-2">
              <span className="text-2xl font-bold text-red-800">{blockedProfiles.length}</span>
              <span className="text-sm text-red-600 ml-2">/ {blockedBalance.toLocaleString()} ₽</span>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Все профили в одном списке */}

      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
              <ShoppingBag className="w-5 h-5 text-white" />
            </div>
            OZON Finance
          </h1>
          <p className="text-slate-500 mt-1">
            Управление профилями • Синхронизация через расширение
          </p>
        </div>
        <div className="flex gap-2 flex-wrap">
          <Button
            onClick={() => setShowCookieModal(true)}
            className="bg-green-600 hover:bg-green-700"
            title="Парсинг через cookies (рекомендуется)"
            data-testid="cookie-parse-btn"
          >
            <Bot className="w-4 h-4" />
            Парсинг (cookies)
          </Button>
          <a 
            href={`${process.env.REACT_APP_BACKEND_URL}/api/build/extension`}
            download
            className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-purple-600 bg-purple-100 hover:bg-purple-200 rounded-lg transition-colors"
            title="Скачать Chrome расширение для автоматического парсинга"
          >
            <Download className="w-4 h-4" />
            Расширение
          </a>
          <Button
            onClick={handleDownloadPhones}
            variant="outline"
            className="border-green-300 text-green-700 hover:bg-green-50"
            title="Скачать номера активных профилей в TXT"
            data-testid="download-phones-btn"
          >
            <FileDown className="w-4 h-4" />
            Скачать номера ({activeProfiles.length})
          </Button>
          <Button 
            onClick={() => fetchOzonProfiles(true)}
            disabled={isRefreshing}
            variant="outline"
            data-testid="refresh-ozon-button"
          >
            {isRefreshing ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
            Обновить
          </Button>
          {selectedProfiles.size > 0 && (
            <Button 
              onClick={handleDeleteSelected}
              disabled={isDeletingMultiple}
              variant="destructive"
              data-testid="delete-selected-button"
            >
              {isDeletingMultiple ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}
              Удалить выбранные ({selectedProfiles.size})
            </Button>
          )}
          <Button 
            onClick={() => setShowAddModal(true)}
            className="bg-blue-600 hover:bg-blue-700"
            data-testid="add-ozon-profile-button"
          >
            <Plus className="w-4 h-4" />
            Добавить профиль
          </Button>
        </div>
      </div>

      {/* Search */}
      <Card className="mb-6">
        <CardContent className="p-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
            <Input
              placeholder="Поиск по телефону, названию или имени..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10"
              data-testid="search-ozon-input"
            />
          </div>
        </CardContent>
      </Card>

      {/* Error */}
      {error && (
        <Card className="mb-6 border-red-200 bg-red-50">
          <CardContent className="p-4 text-red-700">{error}</CardContent>
        </Card>
      )}

      {/* Loading */}
      {isLoading ? (
        <Card>
          <CardContent className="p-8 flex justify-center">
            <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
          </CardContent>
        </Card>
      ) : (
        /* Profiles Table */
        <Card>
          <CardContent className="p-0">
            <Table>
              <TableHeader>
                <TableRow className="bg-slate-50">
                  <TableHead className="w-10">
                    <input
                      type="checkbox"
                      checked={tabFilteredProfiles.length > 0 && selectedProfiles.size === tabFilteredProfiles.length}
                      onChange={toggleSelectAll}
                      className="w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </TableHead>
                  <TableHead className="w-10"></TableHead>
                  <TableHead>Статус</TableHead>
                  <TableHead>ID</TableHead>
                  <TableHead>Имя аккаунта</TableHead>
                  <TableHead>Телефон</TableHead>
                  <TableHead className="text-right">Баланс</TableHead>
                  <TableHead className="text-right">Пополнения</TableHead>
                  <TableHead className="text-right">Переводы</TableHead>
                  <TableHead className="text-right">Действия</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {tabFilteredProfiles.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} className="text-center py-8 text-slate-500">
                      {searchQuery ? "Профили не найдены" : "Нет профилей. Добавьте первый профиль или используйте расширение."}
                    </TableCell>
                  </TableRow>
                ) : (
                  tabFilteredProfiles.map((profile) => (
                    <Collapsible key={profile.id} asChild open={expandedRows[profile.id]}>
                      <>
                        <TableRow 
                          className={`cursor-pointer hover:bg-slate-50 transition-colors ${selectedProfiles.has(profile.id) ? 'bg-blue-50' : ''}`}
                          onClick={() => toggleRow(profile.id)}
                          data-testid={`ozon-profile-row-${profile.id}`}
                        >
                          <TableCell onClick={(e) => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              checked={selectedProfiles.has(profile.id)}
                              onChange={() => toggleProfileSelection(profile.id)}
                              className="w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500"
                            />
                          </TableCell>
                          <TableCell>
                            <CollapsibleTrigger asChild>
                              <Button variant="ghost" size="sm" className="p-0 h-6 w-6">
                                {expandedRows[profile.id] ? 
                                  <ChevronDown className="w-4 h-4" /> : 
                                  <ChevronRight className="w-4 h-4" />
                                }
                              </Button>
                            </CollapsibleTrigger>
                          </TableCell>
                          <TableCell>
                            {profile.is_blocked ? (
                              <div className="w-3 h-3 rounded-full bg-red-500" title="Операции приостановлены" />
                            ) : (
                              <div className="w-3 h-3 rounded-full bg-green-500" title="Активен" />
                            )}
                          </TableCell>
                          <TableCell>
                            <span className="text-slate-500 font-mono text-sm">{profile.ozon_id || '—'}</span>
                          </TableCell>
                          <TableCell>
                            <div className="font-medium text-slate-800">
                              {profile.name || profile.dolphin_profile_name}
                            </div>
                          </TableCell>
                          <TableCell>
                            <span className="text-slate-600">{profile.phone || "—"}</span>
                          </TableCell>
                          <TableCell className="text-right">
                            <span className={`font-semibold ${profile.is_blocked ? 'text-red-600' : 'text-slate-800'}`}>
                              {(profile.balance || 0).toLocaleString()} ₽
                            </span>
                          </TableCell>
                          <TableCell className="text-right">
                            <span className="text-green-600 font-medium">
                              +{getTotalDeposits(profile).toLocaleString()} ₽
                            </span>
                            <div className="text-xs text-slate-400">
                              {getDeposits(profile).length} операций
                            </div>
                          </TableCell>
                          <TableCell className="text-right">
                            <span className="text-orange-600 font-medium">
                              -{getTotalWithdrawals(profile).toLocaleString()} ₽
                            </span>
                            <div className="text-xs text-slate-400">
                              {getWithdrawals(profile).length} операций
                            </div>
                          </TableCell>
                          <TableCell className="text-right">
                            <div className="flex items-center justify-end gap-1">
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={(e) => { e.stopPropagation(); handleCreateRequest(profile); }}
                                className={`h-8 w-8 p-0 font-bold rounded ${
                                  profile.request_sent 
                                    ? 'bg-green-100 text-green-600 hover:bg-green-200 border-2 border-green-500' 
                                    : 'bg-red-100 text-red-600 hover:bg-red-200 border-2 border-red-500'
                                }`}
                                title={profile.request_sent ? "Заявка отправлена" : "Заявка не отправлена"}
                                data-testid={`create-request-${profile.id}`}
                              >
                                <Plus className="w-4 h-4" />
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={(e) => { e.stopPropagation(); handleGenerateCashinoutArchive(profile); }}
                                className="h-8 w-8 p-0 border-2 border-cyan-500 text-cyan-600 hover:text-cyan-800 hover:bg-cyan-50 font-bold rounded"
                                title="Сгенерировать Cashinout архив"
                                data-testid={`cashinout-archive-${profile.id}`}
                              >
                                C
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={(e) => { e.stopPropagation(); handleGenerateBetboomArchive(profile); }}
                                className="h-8 w-8 p-0 border-2 border-yellow-500 text-yellow-600 hover:text-yellow-800 hover:bg-yellow-50 font-bold rounded"
                                title="Сгенерировать Betboom архив"
                                data-testid={`betboom-archive-${profile.id}`}
                              >
                                B
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={(e) => { e.stopPropagation(); generateEmail(profile); }}
                                className="h-8 px-2 text-blue-500 hover:text-blue-700 hover:bg-blue-50"
                                title="Сгенерировать email"
                                data-testid={`generate-email-${profile.id}`}
                              >
                                <AtSign className="w-4 h-4" />
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={(e) => { e.stopPropagation(); launchBrowser(profile); }}
                                className="h-8 px-2 text-blue-500 hover:text-blue-700 hover:bg-blue-50"
                                title="Запустить браузер"
                                data-testid={`launch-browser-${profile.id}`}
                              >
                                <Globe className="w-4 h-4" />
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={(e) => { e.stopPropagation(); openEditModal(profile); }}
                                className="h-8 px-2 text-slate-600 hover:text-slate-800"
                                title="Редактировать"
                                data-testid={`edit-profile-${profile.id}`}
                              >
                                <Edit className="w-4 h-4" />
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={(e) => { e.stopPropagation(); handleDeleteProfile(profile.id); }}
                                className="h-8 px-2 text-red-500 hover:text-red-700 hover:bg-red-50"
                                title="Удалить"
                                data-testid={`delete-profile-${profile.id}`}
                              >
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                        
                        {/* Expanded Row */}
                        <CollapsibleContent asChild>
                          <TableRow className="bg-slate-50/50">
                            <TableCell colSpan={8} className="p-4">
                              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {/* Profile Info */}
                                <div className="space-y-3">
                                  <h4 className="font-semibold text-slate-700 flex items-center gap-2">
                                    <User className="w-4 h-4" />
                                    Профиль
                                  </h4>
                                  <div className="space-y-2 text-sm">
                                    <div className="flex items-center gap-2">
                                      <span className="text-slate-400 w-24">Имя:</span>
                                      <span className="font-medium">{profile.first_name || "—"}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-slate-400 w-24">Фамилия:</span>
                                      <span className="font-medium">{profile.last_name || "—"}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-slate-400 w-24">Пол:</span>
                                      <span className="font-medium">{profile.gender || "—"}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-slate-400 w-24">Город:</span>
                                      <span className="font-medium">{profile.city || "—"}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-slate-400 w-24">Отчество:</span>
                                      <span className="font-medium">{profile.patronymic || "—"}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-slate-400 w-24">Дата рожд.:</span>
                                      <span className="font-medium">{profile.birth_date || "—"}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-slate-400 w-24">Email:</span>
                                      <span className="font-medium">{profile.email || "не установлен"}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-slate-400 w-24">Синхр.:</span>
                                      <span className="font-medium">{profile.last_sync ? new Date(profile.last_sync).toLocaleString('ru-RU') : "—"}</span>
                                    </div>
                                    <div className="flex items-center gap-2 pt-2 border-t border-slate-200 mt-2">
                                      <span className="text-yellow-600 w-24 font-medium">Баланс шаблона:</span>
                                      <span className="font-bold text-yellow-700">{(profile.template_balance || 0).toLocaleString()} ₽</span>
                                    </div>
                                  </div>
                                </div>

                                {/* Deposits */}
                                <div className="space-y-3">
                                  <div className="flex items-center justify-between">
                                    <h4 className="font-semibold text-green-700 flex items-center gap-2">
                                      <ArrowUpCircle className="w-4 h-4" />
                                      Пополнения ({getDeposits(profile).length})
                                    </h4>
                                    <Button
                                      size="sm"
                                      variant="ghost"
                                      className="h-7 px-2 text-green-700 hover:bg-green-100"
                                      onClick={() => openAddTx(profile.id, 'deposit')}
                                      data-testid={`add-deposit-${profile.id}`}
                                      title="Добавить пополнение"
                                    >
                                      <Plus className="w-4 h-4 mr-1" /> Добавить
                                    </Button>
                                  </div>
                                  <div className="space-y-1 max-h-60 overflow-y-auto">
                                    {getDeposits(profile).length === 0 ? (
                                      <p className="text-sm text-slate-400">Нет пополнений</p>
                                    ) : (
                                      getDeposits(profile).map((t, i) => (
                                        <div key={t.id || i} className="group flex justify-between items-center text-sm bg-green-50 p-2 rounded hover:bg-green-100 transition-colors">
                                          <span className="text-slate-600 flex-1 min-w-0 truncate">{t.date} {t.time && <span className="text-slate-400">{t.time}</span>} • {t.category || 'Пополнение'}</span>
                                          <div className="flex items-center gap-2 ml-2">
                                            <span className="text-green-600 font-medium whitespace-nowrap">+{Number(t.amount).toLocaleString()} ₽</span>
                                            <div className="flex opacity-0 group-hover:opacity-100 transition-opacity gap-1">
                                              <button
                                                type="button"
                                                onClick={() => openEditTx(profile.id, t)}
                                                data-testid={`edit-tx-${t.id}`}
                                                className="p-1 rounded hover:bg-green-200 text-slate-500 hover:text-green-700"
                                                title="Редактировать"
                                              >
                                                <Edit className="w-3.5 h-3.5" />
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() => deleteTx(profile.id, t.id)}
                                                data-testid={`delete-tx-${t.id}`}
                                                className="p-1 rounded hover:bg-red-200 text-slate-500 hover:text-red-700"
                                                title="Удалить"
                                              >
                                                <Trash2 className="w-3.5 h-3.5" />
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    )}
                                  </div>
                                </div>

                                {/* Withdrawals */}
                                <div className="space-y-3">
                                  <div className="flex items-center justify-between">
                                    <h4 className="font-semibold text-orange-700 flex items-center gap-2">
                                      <ArrowDownCircle className="w-4 h-4" />
                                      Переводы ({getWithdrawals(profile).length})
                                    </h4>
                                    <Button
                                      size="sm"
                                      variant="ghost"
                                      className="h-7 px-2 text-orange-700 hover:bg-orange-100"
                                      onClick={() => openAddTx(profile.id, 'withdrawal')}
                                      data-testid={`add-withdrawal-${profile.id}`}
                                      title="Добавить перевод"
                                    >
                                      <Plus className="w-4 h-4 mr-1" /> Добавить
                                    </Button>
                                  </div>
                                  <div className="space-y-1 max-h-60 overflow-y-auto">
                                    {getWithdrawals(profile).length === 0 ? (
                                      <p className="text-sm text-slate-400">Нет переводов</p>
                                    ) : (
                                      getWithdrawals(profile).map((t, i) => (
                                        <div key={t.id || i} className="group flex justify-between items-center text-sm bg-orange-50 p-2 rounded hover:bg-orange-100 transition-colors">
                                          <span className="text-slate-600 flex-1 min-w-0 truncate">{t.date} {t.time && <span className="text-slate-400">{t.time}</span>} • {t.category || 'Перевод'}</span>
                                          <div className="flex items-center gap-2 ml-2">
                                            <span className="text-orange-600 font-medium whitespace-nowrap">-{Number(t.amount).toLocaleString()} ₽</span>
                                            <div className="flex opacity-0 group-hover:opacity-100 transition-opacity gap-1">
                                              <button
                                                type="button"
                                                onClick={() => openEditTx(profile.id, t)}
                                                data-testid={`edit-tx-${t.id}`}
                                                className="p-1 rounded hover:bg-orange-200 text-slate-500 hover:text-orange-700"
                                                title="Редактировать"
                                              >
                                                <Edit className="w-3.5 h-3.5" />
                                              </button>
                                              <button
                                                type="button"
                                                onClick={() => deleteTx(profile.id, t.id)}
                                                data-testid={`delete-tx-${t.id}`}
                                                className="p-1 rounded hover:bg-red-200 text-slate-500 hover:text-red-700"
                                                title="Удалить"
                                              >
                                                <Trash2 className="w-3.5 h-3.5" />
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    )}
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        </CollapsibleContent>
                      </>
                    </Collapsible>
                  ))
                )}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}

      {/* Add Profile Modal */}
      <Dialog open={showAddModal} onOpenChange={setShowAddModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Добавить OZON профиль</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Название профиля *</Label>
              <Input
                value={formData.dolphin_profile_name}
                onChange={(e) => setFormData({...formData, dolphin_profile_name: e.target.value})}
                placeholder="Например: OZON_79991234567"
                data-testid="add-profile-name"
              />
            </div>
            <div>
              <Label>Телефон</Label>
              <Input
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                placeholder="79991234567"
                data-testid="add-profile-phone"
              />
            </div>
            <div>
              <Label>Имя</Label>
              <Input
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                placeholder="Имя пользователя"
                data-testid="add-profile-user-name"
              />
            </div>
            <div>
              <Label>Email</Label>
              <Input
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                placeholder="email@example.com"
                data-testid="add-profile-email"
              />
            </div>
            <div>
              <Label>Баланс</Label>
              <Input
                type="number"
                value={formData.balance}
                onChange={(e) => setFormData({...formData, balance: e.target.value})}
                placeholder="0"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => { setShowAddModal(false); resetForm(); }}>
              Отмена
            </Button>
            <Button onClick={handleAddProfile} className="bg-blue-600 hover:bg-blue-700">
              Добавить
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit Profile Modal */}
      <Dialog open={showEditModal} onOpenChange={setShowEditModal}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Редактировать профиль</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Имя</Label>
                <Input
                  value={formData.first_name}
                  onChange={(e) => setFormData({...formData, first_name: e.target.value})}
                  placeholder="Имя"
                />
              </div>
              <div>
                <Label>Фамилия</Label>
                <Input
                  value={formData.last_name}
                  onChange={(e) => setFormData({...formData, last_name: e.target.value})}
                  placeholder="Фамилия"
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Отчество</Label>
                <Input
                  value={formData.patronymic}
                  onChange={(e) => setFormData({...formData, patronymic: e.target.value})}
                  placeholder="Отчество"
                />
              </div>
              <div>
                <Label>Дата рождения</Label>
                <Input
                  type="date"
                  value={formData.birth_date}
                  onChange={(e) => setFormData({...formData, birth_date: e.target.value})}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Пол</Label>
                <select
                  className="w-full p-2 border rounded-lg"
                  value={formData.gender}
                  onChange={(e) => setFormData({...formData, gender: e.target.value})}
                >
                  <option value="">Не указан</option>
                  <option value="Мужской">Мужской</option>
                  <option value="Женский">Женский</option>
                </select>
              </div>
              <div>
                <Label>Город</Label>
                <Input
                  value={formData.city}
                  onChange={(e) => setFormData({...formData, city: e.target.value})}
                  placeholder="Город"
                />
              </div>
            </div>
            <div>
              <Label>Телефон</Label>
              <Input
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
              />
            </div>
            <div>
              <Label>Email</Label>
              <Input
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Баланс OZON</Label>
                <Input
                  type="number"
                  value={formData.balance}
                  onChange={(e) => setFormData({...formData, balance: e.target.value})}
                />
              </div>
              <div>
                <Label className="text-yellow-600">Баланс шаблона</Label>
                <Input
                  type="number"
                  value={formData.template_balance}
                  onChange={(e) => setFormData({...formData, template_balance: e.target.value})}
                  className="border-yellow-300 focus:border-yellow-500"
                  placeholder="1000 - 35000"
                />
              </div>
            </div>

            {/* Cashinout ID — persistent per profile (used in template preview URL) */}
            <div>
              <Label className="text-blue-600">Cashinout ID</Label>
              <Input
                type="number"
                min="0"
                value={formData.cashinout_id || ""}
                onChange={(e) => setFormData({...formData, cashinout_id: e.target.value})}
                className="border-blue-300 focus:border-blue-500"
                placeholder="174625 (виден в шаблоне Cashinout)"
                data-testid="cashinout-id-input"
              />
              <p className="text-xs text-slate-500 mt-1">
                Постоянный ID пользователя для превью Cashinout. Если пусто — сгенерируется случайный.
              </p>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => { setShowEditModal(false); setSelectedProfile(null); resetForm(); }}>
              Отмена
            </Button>
            <Button onClick={handleUpdateProfile} className="bg-blue-600 hover:bg-blue-700">
              Сохранить
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Transaction Add/Edit Modal */}
      <Dialog open={showTxModal} onOpenChange={setShowTxModal}>
        <DialogContent className="max-w-md" data-testid="tx-modal">
          <DialogHeader>
            <DialogTitle>
              {txMode === 'add' ? '➕ Новая транзакция' : '✏️ Редактировать транзакцию'}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Тип</Label>
              <div className="flex gap-2 mt-1">
                <button
                  type="button"
                  onClick={() => setTxForm({...txForm, type: 'deposit', method: txForm.method || 'Пополнение'})}
                  className={`flex-1 px-3 py-2 rounded-lg border font-medium transition-colors ${txForm.type === 'deposit' ? 'bg-green-100 border-green-500 text-green-700' : 'bg-white border-slate-300 text-slate-600 hover:bg-slate-50'}`}
                  data-testid="tx-type-deposit"
                >
                  ↑ Пополнение
                </button>
                <button
                  type="button"
                  onClick={() => setTxForm({...txForm, type: 'withdrawal', method: txForm.method || 'Перевод'})}
                  className={`flex-1 px-3 py-2 rounded-lg border font-medium transition-colors ${txForm.type === 'withdrawal' ? 'bg-orange-100 border-orange-500 text-orange-700' : 'bg-white border-slate-300 text-slate-600 hover:bg-slate-50'}`}
                  data-testid="tx-type-withdrawal"
                >
                  ↓ Перевод
                </button>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div>
                <Label>Дата *</Label>
                <Input
                  type="date"
                  value={txForm.date}
                  onChange={(e) => setTxForm({...txForm, date: e.target.value})}
                  data-testid="tx-date"
                />
              </div>
              <div>
                <Label>Время</Label>
                <Input
                  type="time"
                  value={txForm.time}
                  onChange={(e) => setTxForm({...txForm, time: e.target.value})}
                  data-testid="tx-time"
                />
              </div>
            </div>

            <div>
              <Label>Сумма * (₽)</Label>
              <Input
                type="number"
                step="0.01"
                min="0"
                value={txForm.amount}
                onChange={(e) => setTxForm({...txForm, amount: e.target.value})}
                placeholder="1000"
                data-testid="tx-amount"
              />
            </div>

            <div>
              <Label>Категория</Label>
              <Input
                value={txForm.category}
                onChange={(e) => setTxForm({...txForm, category: e.target.value})}
                placeholder="Магазины / Супермаркеты / Фастфуд / Развлечения / …"
                list="tx-category-suggestions"
                data-testid="tx-category"
              />
              <datalist id="tx-category-suggestions">
                <option value="Магазины" />
                <option value="Супермаркеты" />
                <option value="Фастфуд" />
                <option value="Развлечения" />
                <option value="Коммунальные услуги" />
                <option value="Транспорт" />
                <option value="АЗС" />
                <option value="Аптеки" />
                <option value="Одежда" />
                <option value="Пополнение" />
                <option value="Зарплата" />
                <option value="Перевод от" />
              </datalist>
            </div>

            <div>
              <Label>Метод</Label>
              <Input
                value={txForm.method}
                onChange={(e) => setTxForm({...txForm, method: e.target.value})}
                placeholder="Пополнение / Перевод / СБП / Карта…"
                data-testid="tx-method"
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowTxModal(false)} disabled={txSaving}>
              Отмена
            </Button>
            <Button
              onClick={saveTx}
              disabled={txSaving}
              className={txForm.type === 'deposit' ? 'bg-green-600 hover:bg-green-700' : 'bg-orange-600 hover:bg-orange-700'}
              data-testid="tx-save"
            >
              {txSaving ? <><Loader2 className="w-4 h-4 animate-spin mr-2" />Сохранение…</> : 'Сохранить'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Cookie Parse Modal */}
      <Dialog open={showCookieModal} onOpenChange={setShowCookieModal}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>🍪 Парсинг через Cookies</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div className="bg-green-50 p-4 rounded-lg text-sm">
              <p className="font-medium text-green-900 mb-2">Как получить cookies:</p>
              <ol className="list-decimal list-inside space-y-1 text-green-800">
                <li>Откройте <a href="https://finance.ozon.ru/lk/operations" target="_blank" rel="noopener noreferrer" className="underline">finance.ozon.ru</a> и войдите</li>
                <li>Нажмите F12 → Application → Cookies → finance.ozon.ru</li>
                <li>Скопируйте cookies (особенно __Secure-access-token, __OBANK_session)</li>
                <li>Вставьте в поле ниже в формате:<br/>
                  <code className="bg-green-100 px-1 rounded">имя_cookie: значение</code>
                </li>
              </ol>
            </div>
            
            <div>
              <Label>Cookies (каждый с новой строки)</Label>
              <textarea
                className="w-full h-48 p-3 border rounded-lg font-mono text-sm"
                value={cookiesInput}
                onChange={(e) => setCookiesInput(e.target.value)}
                placeholder={`__Secure-access-token: 10.233047692...
__OBANK_session: eyJhbGci...
__OBANK_refresh: eyJhbGci...
__OBANK_device: eyJhbGci...`}
                data-testid="cookies-input"
              />
            </div>
            
            <div>
              <Label>Период (дней)</Label>
              <select
                className="w-full p-2 border rounded-lg"
                value={cookiePeriod}
                onChange={(e) => setCookiePeriod(parseInt(e.target.value))}
                data-testid="period-select"
              >
                <option value={7}>7 дней</option>
                <option value={15}>15 дней</option>
                <option value={30}>30 дней</option>
                <option value={60}>60 дней</option>
              </select>
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowCookieModal(false)}>
              Отмена
            </Button>
            <Button 
              onClick={handleCookieParse} 
              className="bg-green-600 hover:bg-green-700"
              disabled={isCookieParsing}
            >
              {isCookieParsing ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin mr-2" />
                  Парсинг...
                </>
              ) : (
                <>
                  <Bot className="w-4 h-4 mr-2" />
                  Запустить парсинг
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
